// Feature-scoped query-key factory for the Publication View vertical.
// Params are kept as objects in the key so `queryClient.setQueryData` /
// `invalidateQueries` can target exact matches, and broad prefix matches
// (e.g. `[...all, 'foldersHierarchy']`) sweep every param variant.

export type PublicationIdKeyParams = {
  publicationId: string;
};

export type FoldersHierarchyKeyParams = {
  publicationId: string;
  entityId: number;
  // Access-control filter from subjectClaims: 'All' or a list of section ids.
  // Part of the key so a claims change refetches the correct subtree.
  sectionIds: 'All' | string[];
};

export type TemplatesKeyParams = {
  isOpenGovAdmin: boolean;
  entityId: number;
  page: number;
  perPage?: number;
  sort?: string;
  title?: string;
  shouldFilterByUser?: boolean;
  ogId?: number;
};

export const publicationViewQueryKeys = {
  all: ['publicationView'] as const,
  publication: (params: PublicationIdKeyParams) =>
    [...publicationViewQueryKeys.all, 'publication', params] as const,
  foldersHierarchy: (params: FoldersHierarchyKeyParams) =>
    [...publicationViewQueryKeys.all, 'foldersHierarchy', params] as const,
  templates: (params: TemplatesKeyParams) =>
    [...publicationViewQueryKeys.all, 'templates', params] as const,
  stories: (params: object) => [...publicationViewQueryKeys.all, 'stories', params] as const,
  reportEmbeds: (params: object) => [...publicationViewQueryKeys.all, 'reportEmbeds', params] as const
};
